import { render, staticRenderFns } from "./GameResultModule.vue?vue&type=template&id=0993515c&"
import script from "./GameResultModule.vue?vue&type=script&lang=js&"
export * from "./GameResultModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports